import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useGetRegionDetailQuery,
  useUpdateRegionMutation,
} from "store/services/LocationsApi/regionApi";
import RegionForm from "./regionComponents/RegionForm";
import { toast } from "react-toastify";

const RegionEditScreen = () => {
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { from } = location.state || {};

  const breadcrumbs = [
    { title: "Regions", path: "/app/crm/region/list" },

    from === "detail" && {
      title: "Region Detail",
      path: `/app/crm/region/${id}/detail`,
    },
    { title: "Edit Region" },
  ].filter(Boolean);

  const {
    data: regionDetail,
    isLoading: loadingRegionDetail,
    error,
  } = useGetRegionDetailQuery(id);

  const [updateRegion, { isLoading: updatingRegion }] =
    useUpdateRegionMutation();

  const handleRegionUpdate = async (data) => {
    try {
      await updateRegion({
        ...data,
        id,
        country: data.country?._id,
      }).unwrap();
      toast.success("Region successfully updated!");
      navigate(from === "detail" ? breadcrumbs[1].path : breadcrumbs[0].path);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create Region!"
      );
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      loading={loadingRegionDetail || updatingRegion}
    >
      <BreadcrumbLayout.Paper>
        <BreadcrumbLayout.Error error={error} />

        <RegionForm
          regionDetail={regionDetail}
          isBusy={loadingRegionDetail || updatingRegion}
          onSubmit={handleRegionUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default RegionEditScreen;
